<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4 v-if="orderState == 'todo'">待呼商机</h4>
        <h4 v-else-if="orderState == 'done'">我参与的通话</h4>
        <h4 v-else>任务列表</h4>
      </div>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入任务id/任务名称/客户手机号"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'is:state|integer#and': state == 'all' ? null : 1,
                'fpi-regex:name|string#or': searchValue,
                'fpi-regex:phone|string#or': searchValue,
                'fpi-regex:_id|string#or': searchValue,
                beanName: 'supportHubItem',
                title: '任务明细'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <c-table :fields="extFields">
            <template slot="userId">
              <el-table-column
                prop="userId"
                label="执行客服"
                show-overflow-tooltip
                :formatter="formatUsers"
                width="100px"
              ></el-table-column>
            </template>
          </c-table>
          <el-table-column fixed="right" width="100" label="操作">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item v-if="!orderState" @click.native="toCustomer(scope.row)">
                    分配客服
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="新增任务明细" :visible.sync="openDetail">
      <c-form
        :formData="formData"
        :fields="extFields"
        :area="area"
        :upload="upload"
        :options="options"
        ref="form"
        labelWidth="150px"
        @changeForm="osg.changeForm"
      ></c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="分配客服" :visible.sync="toCustomerShow">
      <el-form ref="formData" :model="formData">
        <el-form-item
          label="执行客服"
          prop="userId"
          :rules="{
            required: true,
            trigger: ['blur', 'change'],
            message: '执行客服不能为空'
          }"
        >
          <el-select v-model="formData.userId" clearable>
            <template v-for="item in options.users">
              <el-option :key="item.value" :label="item.name" :value="item.value"></el-option>
            </template>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'supportHubItem',
  data() {
    window.$this = this;
    return {
      name: 'supportHubItem',
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: {
        images: [],
        videos: []
      },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        codecfg_deductType: { codeId: 'deductType' },
        users: []
      },
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      log: {
        show: false,
        fpi: {
          data: []
        }
      },
      orderState: '', //全部任务 待呼商机todo 已办商机done
      currentRole: {}, //当前角色
      toCustomerShow: false
    };
  },
  mounted() {
    this.doInit();
    let account = JSON.parse(sessionStorage['loginAccount'] || sessionStorage['entity']);
    this.userId = account._id;
    this.currentRole = JSON.parse(sessionStorage['currentRole']) || {};
    this.osg.getFields('supportHubItem', () => {
      this.orderState = this.osg.param('orderState');
      this.osg.getFpi();
      this.getData();
      this.getUsers();
    });
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = { images: [], videos: [], exts: {} };
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getData() {
      let params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'in:state|array-integer#and': '1',
        sortField: 'createTime',
        sortOrder: 'desc',
        'regex:name|string#or': this.searchValue,
        'regex:phone|string#or': this.searchValue,
        'regex:num|string#or': this.searchValue,
        'is:_id|string#or': this.searchValue,
        'is:supportHubId|string#or': this.searchValue
        // 'is:userId|string#and':
        //   this.orderState == 'todo' || this.orderState == 'done' ? this.userId : null // 需求改为均可见
      };
      if (this.orderState == 'todo') {
        params['ne:taskStatus|integer#and'] = 99;
      } else if (this.orderState == 'done') {
        params['is:taskStatus|integer#and'] = 99;
      }
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('/basic/supportHub/querySupportHubItem.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doSave() {
      if (this.osg.validate()) {
        this.$util.saveFormatExtField(this.extFields, this.formData);
        let params = this.$util.deepCopy(this.formData);
        // 回访记录二级数组转字符串用于存储
        params.exts.followUp = JSON.stringify(params.exts.followUp);
        this.osg.ajax('basic/supportHub/upsertSupportHubItem.do', params, () => {
          this.doInit();
          this.getData();
          this.osg.toast('操作成功！');
        });
      }
    },
    doEdit(row) {
      row = this.$util.deepCopy(row);
      this.$util.renderExtField(this.extFields, row);
      row.images = row.images || [];
      row.videos = row.videos || [];
      row.taskStatus = JSON.stringify(row.taskStatus);
      this.formData = row;
      this.openDetail = true;
      this.$forceUpdate();
    },
    formatUsers(row, column, cellValue) {
      return this.osg.codelabel('users', cellValue);
    },
    getUsers() {
      this.osg.ajax(
        'user/query.do',
        {
          _all: '1',
          notFilterOrgId: '1',
          notFilterBelongTo: '1',
          'in:roleIds|array#and': '812337714845629049'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.users = res.data;
          console.log(this.options.users, '---this.options.users');
        },
        { noload: true }
      );
    },
    // 分配客服
    toCustomer(row) {
      row = this.$util.deepCopy(row);
      this.formData = row;
      this.toCustomerShow = true;
      this.$forceUpdate();
    }
  },
  watch: {
    $route() {
      // window.$this = this;
      this.orderState = this.osg.param('orderState');
      // this.doInit();
      // this.osg.getFpi();
      // this.getData();
    },
    //area 级联组件点击label就消失
    'formData.area'() {
      if (this.$refs.areaSelector) {
        this.$refs.areaSelector.dropDownVisible = false; //监听值发生变化就关闭它
      }
    },
    'formDataSA.area'() {
      if (this.$refs.areaSelectorSA) {
        this.$refs.areaSelectorSA.dropDownVisible = false; //监听值发生变化就关闭它
      }
    },
    //信息渠道,级联组件点击label就消失
    'formData.channel'() {
      if (this.$refs.channelCascader) {
        this.$refs.channelCascader.dropDownVisible = false; //监听值发生变化就关闭它
      }
    }
  }
};
</script>
